module.exports = __webpack_public_path__ + "media/components/live/rdc/images/listing-performance-c9f9ac7823be9a0ed8d0ef2d826d1bd8.png";